import React from 'react';
import { CampaignCard } from './CampaignCard';
import { CampaignCardSkeleton } from './AffiliateDashboardCardSkeleton';

export const CampaignSection = ({
    title,
    data,
    icon,
    iconColor,
    status,
    counts,
    loading,
    setShowAnalytics,
    setCommissionModal,
    setBrandDetailsModal,
    copied,
    setCopied,
    selectedCampaign,
    setSelectedCampaign,
    isDialogOpen,
    setIsDialogOpen,
    selectedMediaType,
    setSelectedMediaType,
    youtubeUrls,
    setYoutubeUrls,
    newYoutubeLink,
    setNewYoutubeLink,
    instagramUrls,
    setInstagramUrls,
    newInstagramLink,
    setNewInstagramLink,
    mediaError,
    mediaSuccess,
    mediaLoading,
    handleAddMedia,
    openConfirmationModal,
    toast,
    onCampaignsRefresh,
}) => {
    const allCampaigns = Object.values(data || {}).flatMap(company =>
        Object.values(company.brands || {}).flatMap(brand =>
            (brand.campaigns || []).map(campaign => ({
                ...campaign,
                companyName: company.companyName,
                companyEmail: company.companyEmail,
                companyPhone: company.companyPhone,
                brandName: brand.brandName,
            }))
        )
    );

    return (
        <div className="mb-6 lg:mb-8">
            <h2 className="text-base sm:text-lg font-bold text-gray-900 mb-4 flex items-center gap-2">
                <span className="mr-1 inline-flex shrink-0" style={iconColor && iconColor !== 'transparent' ? { color: iconColor } : undefined}>{icon}</span>
                {title}{' '}
                <span className="text-sm sm:text-base font-semibold text-gray-600">({counts[status]})</span>
            </h2>
            {loading ? (
                <div className="space-y-4">
                    <CampaignCardSkeleton />
                    <CampaignCardSkeleton />
                    <CampaignCardSkeleton />
                </div>
            ) : allCampaigns.length === 0 ? (
                <div className="text-center py-8 bg-white rounded-lg border-2 border-dashed border-gray-300">
                    <p className="text-gray-500 text-sm sm:text-base">No campaigns in this category.</p>
                </div>
            ) : (
                <div className="space-y-4">
                    {allCampaigns.map(campaign => (
                        <CampaignCard
                            key={campaign._id}
                            campaign={campaign}
                            companyName={campaign.companyName}
                            brandName={campaign.brandName}
                            companyEmail={campaign.companyEmail}
                            companyPhone={campaign.companyPhone}
                            setShowAnalytics={setShowAnalytics}
                            setCommissionModal={setCommissionModal}
                            setBrandDetailsModal={setBrandDetailsModal}
                            copied={copied}
                            setCopied={setCopied}
                            selectedCampaign={selectedCampaign}
                            setSelectedCampaign={setSelectedCampaign}
                            isDialogOpen={isDialogOpen}
                            setIsDialogOpen={setIsDialogOpen}
                            selectedMediaType={selectedMediaType}
                            setSelectedMediaType={setSelectedMediaType}
                            youtubeUrls={youtubeUrls}
                            setYoutubeUrls={setYoutubeUrls}
                            newYoutubeLink={newYoutubeLink}
                            setNewYoutubeLink={setNewYoutubeLink}
                            instagramUrls={instagramUrls}
                            setInstagramUrls={setInstagramUrls}
                            newInstagramLink={newInstagramLink}
                            setNewInstagramLink={setNewInstagramLink}
                            mediaError={mediaError}
                            mediaSuccess={mediaSuccess}
                            mediaLoading={mediaLoading}
                            handleAddMedia={handleAddMedia}
                            openConfirmationModal={openConfirmationModal}
                            toast={toast}
                            onCampaignsRefresh={onCampaignsRefresh}
                        />
                    ))}
                </div>
            )}
        </div>
    );
};

